import * as Yup from 'yup';
import { StepSubjectForm } from './step-subject-types';

export const stepSubjectSchema = () =>
  Yup.object<StepSubjectForm>().shape({
    operator: Yup.mixed().nullable().required('Povinné pole'),
  });
